<template>
  <div>
    <h3  style="text-align: center;">AUTORIZACIÓN EXPRESA DE LOS CANALES DE COMUNICACIÓN Y CONTACTO</h3>
    <p>De acuerdo con lo establecido en la ley 2300 del 10 de julio de 2023, a partir del 16 de noviembre de 2023, 
    se utilizarán para efectos de actividad de cobranza, comerciales, publicitarias, envío de correspondencia y 
    notificaciones, los siguientes canales de contacto con usted: Llamada telefónica, mensajería de texto, 
    mensajería por aplicaciones móviles y web, correo electrónico, correspondencia física y visita domiciliaria. 
    En el evento que no se establezca un contacto directo, se podrá realizar visita a la dirección de residencia 
    registrada en nuestra base de datos. Si requiere realizar alguna modificación a los canales de contacto indicados, 
    es necesario que lo notifique por correo electrónico, correo físico o acercándose a  cualquiera de las oficinas de
    La Fundación Apoyo, de lo contrario usted acepta y autoriza ser contactado a través de los canales indicados. 
    En caso de ilocalización, La Fundación Apoyo amparada en la Ley 1266 del 31 de diciembre de 2008 y la Ley 2157 
    del 29 de octubre de 2021, podrá utilizar cualquier canal de comunicación para cumplir con el deber de informar y
    notificar oportunamente el estado de sus obligaciones.</p>

  </div>
</template>

<script>
export default {
  name: 'aporte_titulo_donacion',
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>